export default __webpack_public_path__ + "static/media/mobile_menu.3ee3dd88.svg";